import { Button, Paper, TextField } from '@mui/material';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useEffect, useState } from 'react';

import { db } from '../../firebase';

export default function AddPlyToLadder(props) {

    // ## search player to add to ladder
    const [chosenPly, setChosenPly] = useState(null)
    const title = 'Search player to add to ladder'
    const [playerPool, setPlayerPool] = useState([])
    const optionLabelMap = (ply) => `${ply.Name}, ${ply.Email}`
    const addPly2Ladder = ((ply) => {
        // doc.create to avoid overwriting exisiting ply data
        db.collection('ladder').doc(ply.uid)
            .set({}, { merge: true })

    })

    function getPlayerPool() {
        db.collection("appusers").get()
            .then((querySnapShot) => {
                let plyPool = []
                querySnapShot.forEach((doc) => {
                    const data = doc.data()
                    const player = {
                        Name: data.displayName,
                        Email: data.email,
                        Uid: data.uid,
                    }
                    plyPool.push(player)
                })
                setPlayerPool(plyPool)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function addPlr2Ladder() {
        console.log(chosenPly.Uid)
        db.collection('ladder').doc(chosenPly.Uid)
            .set({
                uid: chosenPly.Uid,
                name: chosenPly.Name
            }, { merge: true })
            .then(() => {
                console.log(`${chosenPly.Name} ${chosenPly.Uid} successfully added to ladder`)
                props.fetchLadder()
                props.setSnackbar({ children: `User ${chosenPly.Name} successfully added to ladder`, severity: 'success' });

            })
            .catch((e) => {
                console.log(e)
                props.setSnackbar({ children: e, severity: 'error' });
            })
    }

    useEffect(() => {
        getPlayerPool()
    }, [])

    return (

        <div>

            <Paper className='center margin padding flex'>
                <h5>Search player to add to ladder: </h5>
                <Autocomplete
                    id="search-bar"
                    onChange={(event, newval) => {
                        setChosenPly(newval)
                    }}
                    options={playerPool}
                    getOptionLabel={(option) => option.Name + ' ' + option.Email}
                    style={{ width: 400 }}
                    renderInput={(params) => <TextField {...params} label="Users" />}
                />

                <Button variant='outlined' color='success' onClick={addPlr2Ladder} >Add</Button>
            </Paper>
        </div>
    )
}
